// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"453137e9","239":"cccd360b","453":"59a1b253","455":"3edc3a11"}[chunkId] + ".chunk.js";
};